export const frag = /*glsl*/ `
precision mediump float;

uniform sampler2D tMap;
uniform sampler2D tAo;
uniform sampler2D tNoise;

uniform vec3 uColor;
uniform vec3 uMaterialColor;

uniform vec2 uUvScale;
uniform vec2 uMapDirection;

uniform float uVisiblity;

uniform float uIntensity;
uniform float uColorInfluence;
uniform float uSaturation;
uniform float uHueShift;
uniform float uMapAnimation;
uniform float uAoIntensity;
uniform float uAoLuminosity;
uniform float uMaterialColorInflence;
uniform float uMapContrast;
uniform float uAoContrast;
uniform float uCoolEffectIntensity;

varying vec2 vUv;
varying float vTime;
varying vec3 vPosition;

#define PI 3.141592

vec3 czm_saturation(vec3 rgb, float adjustment) {
    return mix(vec3(dot(rgb, vec3(0.2125, 0.7154, 0.0721))), rgb, adjustment);
}

vec3 hueShift(vec3 color, float hue) {
    vec3 k = vec3(0.57735, 0.57735, 0.57735);
    float cosAngle = cos(hue);
    return vec3(color * cosAngle + cross(k, color) * sin(hue) + k * dot(k, color) * (1.0 - cosAngle));
}
float pow2(float x) { return x*x; }
#define FAR 200.

void main(){
	float noise = texture2D(tNoise, (vec2(vPosition.x, vPosition.y * 2.) + vPosition.z) * .0004).r;
	float visibility = 1. - uVisiblity;
	float progress = smoothstep(visibility - .01, visibility, noise);

	if(progress < .01) discard;

	vec2 rUv = vUv + vTime * .0001 * uMapAnimation * uMapDirection;

	vec3 map = (texture2D(tMap, rUv * uUvScale).rgb * uMapContrast) - (uMapContrast - 1.) * .5;
	map += uMaterialColor * uMaterialColorInflence;
	vec3 base = mix(map, uColor * length(map), uColorInfluence) * uIntensity;
	
	vec3 color = czm_saturation(base, uSaturation);
	color = hueShift(color, length(map) * uHueShift);
	
	vec3 ao = (texture2D(tAo, vUv).rgb * uAoContrast) - (uAoContrast - 1.) * .5;
	color = mix(color, uColor, smoothstep(.5, 0., progress));
	color = mix(color, (color + uAoLuminosity) * mix(ao, uColor * length(ao), uColorInfluence), uAoIntensity);

	gl_FragColor = vec4(color - uCoolEffectIntensity * .2, 1.);
}`;
